export default __webpack_public_path__ + "static/media/02.e0d88897.jpg";